//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import {
  ReviewMediaList,
} from '@api/vendor.service'

export default {
  name: 'ReviewsMedia',
  props: {
    id: [Number, String],
    type: String,
    initOption: {
      type: Object,
      default: () => ({
        slidesToShow: 6,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 564,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 1439,
            settings: {
              slidesToShow: 4,
            },
          },

          {
            breakpoint: 1599,
            settings: {
              slidesToShow: 5,
            },
          },

        ],
      }),
    },
  },
  data() {
    const laptopDivisionWidth = 1200;
    return {
      isDesktop: laptopDivisionWidth <= window.innerWidth,
      list: [],
      timestamp: new Date(),
      options: {
        prevArrow: '<i class="controls controls--variant_default controls-left "><svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M2.28736 7.71079C2.19363 7.61783 2.11924 7.50723 2.06847 7.38537C2.0177 7.26351 1.99156 7.13281 1.99156 7.00079C1.99156 6.86878 2.0177 6.73808 2.06847 6.61622C2.11924 6.49436 2.19363 6.38376 2.28736 6.29079L6.87736 1.71079C6.97109 1.61783 7.04548 1.50723 7.09625 1.38537C7.14702 1.26351 7.17316 1.1328 7.17316 1.00079C7.17316 0.868781 7.14702 0.738075 7.09625 0.616216C7.04548 0.494357 6.97109 0.383756 6.87736 0.290792C6.69 0.104542 6.43655 0 6.17236 0C5.90817 0 5.65472 0.104542 5.46736 0.290792L0.87736 4.88079C0.315558 5.44329 0 6.20579 0 7.00079C0 7.7958 0.315558 8.55829 0.87736 9.12079L5.46736 13.7108C5.65362 13.8955 5.90502 13.9997 6.16736 14.0008C6.29897 14.0016 6.42943 13.9763 6.55127 13.9266C6.6731 13.8768 6.78392 13.8035 6.87736 13.7108C6.97109 13.6178 7.04548 13.5072 7.09625 13.3854C7.14702 13.2635 7.17316 13.1328 7.17316 13.0008C7.17316 12.8688 7.14702 12.7381 7.09625 12.6162C7.04548 12.4944 6.97109 12.3838 6.87736 12.2908L2.28736 7.71079Z" fill="#242424"/></svg></i>',
        nextArrow: '<i class="controls controls--variant_default controls-right  "><svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M2.28736 7.71079C2.19363 7.61783 2.11924 7.50723 2.06847 7.38537C2.0177 7.26351 1.99156 7.13281 1.99156 7.00079C1.99156 6.86878 2.0177 6.73808 2.06847 6.61622C2.11924 6.49436 2.19363 6.38376 2.28736 6.29079L6.87736 1.71079C6.97109 1.61783 7.04548 1.50723 7.09625 1.38537C7.14702 1.26351 7.17316 1.1328 7.17316 1.00079C7.17316 0.868781 7.14702 0.738075 7.09625 0.616216C7.04548 0.494357 6.97109 0.383756 6.87736 0.290792C6.69 0.104542 6.43655 0 6.17236 0C5.90817 0 5.65472 0.104542 5.46736 0.290792L0.87736 4.88079C0.315558 5.44329 0 6.20579 0 7.00079C0 7.7958 0.315558 8.55829 0.87736 9.12079L5.46736 13.7108C5.65362 13.8955 5.90502 13.9997 6.16736 14.0008C6.29897 14.0016 6.42943 13.9763 6.55127 13.9266C6.6731 13.8768 6.78392 13.8035 6.87736 13.7108C6.97109 13.6178 7.04548 13.5072 7.09625 13.3854C7.14702 13.2635 7.17316 13.1328 7.17316 13.0008C7.17316 12.8688 7.14702 12.7381 7.09625 12.6162C7.04548 12.4944 6.97109 12.3838 6.87736 12.2908L2.28736 7.71079Z" fill="#242424"/></svg></i>',
        dots: false,
        preload: true,
        focusOnSelect: false,
        arrows: true,
        infinite: true,
        ...this.initOption,
      },
    }
  },
  created() {
    this.getList()
  },
  methods: {
    photoMap() {
      return this.list.map(el => el.props.image)
    },
    show(index) {
      console.log(index);
      this.$modal.show(
        () => import('@app/Review/MediaDetail'),
        {
          list: this.list,
          index,
        },
        {
          height: 'auto',
          classes: 'loadPopup',
          adaptive: true,
          scrollable: true,
        }
      )
    },
    async getList() {
      const media = ['photos', 'videos']
      media.forEach(async key => {
        const { data: { items } } = (await ReviewMediaList.execute({ key, type: this.type, id: this.id }))
        console.log(items);
        this.list.push(...items)
        // this.timestamp = new Date()
      })
    },
  },
}
